<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 3V.75l-3 3 3 3V4.5c2.482 0 4.5 2.018 4.5 4.5 0 .758-.188 1.477-.525 2.1l1.095 1.095c.585-.922.93-2.018.93-3.195 0-3.315-2.685-6-6-6Zm0 10.5A4.504 4.504 0 0 1 4.5 9c0-.758.188-1.478.525-2.1L3.93 5.805A5.948 5.948 0 0 0 3 9c0 3.315 2.685 6 6 6v2.25l3-3-3-3v2.25Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
